import * as d3 from 'd3'

export default {

  methods: {

    draw_EPCs() {

      let cir = this.circle

      let chart = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.circle.x}, ${this.circle.y})`)

      let cx = 0
      this.circle.phase.forEach((col,i)=> {

        let data = this.rawData.find(f=> f.PHASE == col.name)

        
        let chartGroup = chart
        .append('g')
        .attr('transform', `translate(${cx}, ${col.radius})`)

        // Title
        chartGroup
        .append('text')
        .attr('x', 0).attr('y', col.radius + 10 + 12*0.75)
        .attr('fill', '#000').attr('font-size', 12)
        .attr('text-anchor', 'middle')
        .text(col.name)

        // Sub-Title
        chartGroup
        .append('text')
        .attr('x', 0).attr('y', col.radius + 25 + 9*0.75)
        .attr('fill', '#757575').attr('font-size', 9)
        .attr('text-anchor', 'middle')
        .text(col.sub)


        let plan = chartGroup // PLAN
        .append('g')
        .attr('transform', `translate(${-2}, ${-24})`)

        plan
        .append('text')
        .attr('id', `PLAN_${this.localId}_${i}`)
        .attr('x', 0).attr('y', 13).attr('fill', '#757575').attr('font-size', 10).attr('text-anchor', 'middle')
        .text(data.PLAN)

        plan
        .append('text')
        .attr('x', this.getNode(`#PLAN_${this.localId}_${i}`)/2).attr('y', 13)
        .attr('fill', '#757575').attr('font-size', 9).text('%')


        let actual = chartGroup // ACTUAL
        .append('g')
        .attr('transform', `translate(${-2}, ${-7})`)

        actual
        .append('text')
        .attr('id', `ACT_${this.localId}_${i}`)
        .attr('x', 0).attr('y', 13).attr('fill', '#333').attr('font-size', 14).attr('text-anchor', 'middle')
        .text(data.ACTUAL)

        actual
        .append('text')
        .attr('x', this.getNode(`#ACT_${this.localId}_${i}`)/2).attr('y', 13)
        .attr('fill', '#333').attr('font-size', 9).text('%')


         let delta = chartGroup // DELTA
        .append('g')
        .attr('transform', `translate(${-6}, ${9})`)

        delta
        .append('text')
        .attr('id', `DELTA_${this.localId}_${i}`)
        .attr('x', 0).attr('y', 13).attr('fill', this.gmx_deltaValue(data.DELTA))
        .attr('font-size', 12).attr('text-anchor', 'middle')
        .text(data.DELTA)

        delta
        .append('text')
        .attr('x', this.getNode(`#DELTA_${this.localId}_${i}`)/2).attr('y', 13)
        .attr('fill', this.gmx_deltaValue(data.DELTA)).attr('font-size', 9).text('%')
        
        delta
        .append('path')
        .attr('transform', `translate(${this.getNode(`#DELTA_${this.localId}_${i}`)/2 + 7}, ${4.5}) scale(${.7})`)
        .attr('d', this.gmx_deltaValue(data.DELTA, 'icon'))
        .attr('fill', this.gmx_deltaValue(data.DELTA))
        

        if(data.ACTUAL<0.1) data.ACTUAL = 0.00001
        this.draw_EPC_Circle(chart, cx, col, data.ACTUAL) // -----> Below
        cx = cx + (cir.space + (col.radius*2))
      })

    },



    draw_EPC_Circle(selection, cx, col, prog) {

      let cir = this.circle
      let endAn = ''

      let bRadius = col.radius - ((col.thick - 1)/2)

      let arc1 = d3.arc()
      .outerRadius(bRadius)
      .innerRadius(bRadius - 1)
      .startAngle(Math.PI / 180)
      .endAngle(() => endAn || 360 * Math.PI / 180)

      let arc2 = d3.arc()
      .outerRadius(col.radius)
      .innerRadius(col.radius - col.thick)
      .startAngle(Math.PI / 180)
      .endAngle(() => endAn || 360 * Math.PI / 180)
      .cornerRadius(col.thick)

      let chart = selection
      .append('g')
      .attr('transform', `translate(${cx}, ${col.radius})`)
      .call(this.call_Link, col.name )

      chart
      .append('circle')
      .attr('cx', 0).attr('cy', 0).attr('r', col.radius)
      .attr('fill', '#E0E0DF').attr('opacity', 0)
      chart
      .append('path')
      .attr('d', arc1).attr('fill', '#E0E0DF').attr('opacity', 1)

      chart
      .append('path')
      .attr('d', arc2)
      .attr('fill', col.color).attr('opacity', col.opacity)
      .transition().duration(500)
      .attrTween('d', ()=> {
        let endAngle_ = ( ((360 * (prog/100)) ) * Math.PI / 180)
        let interpolate = d3.interpolate(0 * Math.PI / 180, endAngle_)
        return function(t) {
          endAn = interpolate(t)
          return arc2()
        }
      })
    },

  } 
}